import React from "react"
import { ModalContext } from "./context/ModalContext"
import { MobileNavContext } from "./context/MobileNav"

export default function wrapWithProvider({ element }) {
    return (
        <ModalContext>
            <MobileNavContext>
                {element}
            </MobileNavContext>
        </ModalContext>
    )
}